import styled from 'styled-components';

export const StyledSpriteText = styled.p`
  margin: 0px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #e5e1e6;
`;

export const StyledSpriteContainer = styled.a`
  text-align: center;
`;

export const StyledGalleryContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  gap: 104px;
`;
